const t=t=>{const e=!!t.url&&!!t.title;return e||console.error(`RelatedArticles: item ${t.uid} has title="${t.title}" and url="${t.url}" which is invalid. it will not be shown`),e};export{t as validateCardProps};
//# sourceMappingURL=index.js.map
